import { render, staticRenderFns } from "./WiganCity.vue?vue&type=template&id=eacea10e&scoped=true&"
import script from "./WiganCity.vue?vue&type=script&lang=js&"
export * from "./WiganCity.vue?vue&type=script&lang=js&"
import style0 from "./WiganCity.vue?vue&type=style&index=0&id=eacea10e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eacea10e",
  null
  
)

export default component.exports